import kinks from '@turf/kinks';
import GeoJSON from 'ol/format/GeoJSON.js';
import toTurf from './toTurf.js';

export default function checkKinkedFeature(feature, mapProjection = window.mapProjection||'EPSG:3857') {
    if (feature.getGeometry().getType() != 'Polygon') {
        return false;
    }
    var format = new GeoJSON();
    var turfedFeature = toTurf(feature, mapProjection, format);
    return kinks(turfedFeature).features.length == 0 ? false : true;
}
